import {GetBookingByIdQuery, GetBookingByIdWithCourseLessonBookingsQuery} from "../../../generated/graphql";

type BookingData =
    | GetBookingByIdQuery["bookingById"]
    | GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"]
    | undefined;

// Bedingungen:
//   - !isCanceled         → stornierte Buchungen sind nicht mehr editierbar
//   - hasInvoice          → nur abgerechnete Buchungen
//   - allowLessonBooking  → Feature-Bedingung des Kurses (Standard-Buchungen ausgeschlossen)
//   - !allPaymentsDone || hasUnbookedLessons
//                         → entweder existiert mind. eine offene Rate (klassischer
//                           Add/Remove-Pfad), oder der Kurs hat noch ungebuchte
//                           Lektionen, die der Admin aktivieren kann (Add-Pfad
//                           auch bei vollständig bezahlter Buchung). Letzteres ist
//                           sicher, weil die Phase-15.3-Pure-Function für den
//                           paid > newTotalGross-Edge-Case einen Early-Return
//                           macht und keine paid SPs mutiert.
export const canAdjustLessonBooking = (booking: BookingData): boolean => {
    if (!booking) return false;

    const isCanceled = booking.canceled !== null && booking.canceled !== undefined;
    const hasInvoice = Boolean(booking.invoice?.id);
    const allowLessonBooking =
        (booking as GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"])?.courseLessons?.[0]?.course?.allowLessonBooking ?? false;

    const scheduledPaymentsList =
        ((booking as unknown) as {scheduledPayments?: Array<{paymentDone?: unknown}>})?.scheduledPayments ?? [];
    const allPaymentsDone =
        scheduledPaymentsList.length > 0 && scheduledPaymentsList.every((sp) => sp.paymentDone !== null && sp.paymentDone !== undefined);

    const courseLessonsCount = (booking as GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"])?.courseLessons?.length ?? 0;
    const courseLessonBookingsCount =
        (booking as GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"])?.courseLessonBookings?.length ?? 0;
    const hasUnbookedLessons = courseLessonsCount > courseLessonBookingsCount;

    return !isCanceled && hasInvoice && allowLessonBooking && (!allPaymentsDone || hasUnbookedLessons);
};
